// "Show" choices for the groupings in the main Grouping menu, shared with the Advanced Group Options dialog.
export const famViewOptions = [
    {value:'1', label:'1 Patent Number per Family'},
    {value:'3', label:'3 Patent Numbers per Family'},
    {value:'5', label:'5 Patent Numbers per Family'},
    {value:'All', label:'All'}
];
export const pnViewOptions = [
    {value:'1', label:'1 Alignment per Patent Number'},
    {value:'3', label:'3 Alignments per Patent Number'},
    {value:'5', label:'5 Alignments per Patent Number'},
    {value:'10', label:'10 Alignments per Patent Number'},
    {value:'All', label:'All'}
];
export const ssvOptions = [
    {value:'1', label:'1 Alignment per Subject Seq.'},
    {value:'3', label:'3 Alignments per Subject Seq.'},
    {value:'5', label:'5 Alignments per Subject Seq.'},
    {value:'10', label:'10 Alignments per Subject Seq.'},
    {value:'All', label:'All'}
];
export const ufsOptions = [
    {value:'1', label:'1 Alignment per UFS'},
    {value:'3', label:'3 Alignments per UFS'},
    {value:'5', label:'5 Alignments per UFS'},
    {value:'10', label:'10 Alignments per UFS'},
    {value:'All', label:'All'}
];
export const qsOptions = [
    {value:'1', label:'1 Alignment per Query Seq.'},
    {value:'3', label:'3 Alignments per Query Seq.'},
    {value:'5', label:'5 Alignments per Query Seq.'},
    {value:'10', label:'10 Alignments per Query Seq.'},
    {value:'All', label:'All'}
];
export const hspOptions = [
    {value:'1', label:'1 Alignment per Blast HSPs'},
    {value:'3', label:'3 Alignments per Blast HSPs'},
    {value:'5', label:'5 Alignments per Blast HSPs'},
    {value:'10', label:'10 Alignments per Blast HSPs'},
    {value:'All', label:'All'}
];
